import { branchConstants } from '../constants';

export function branches(state = {}, action) {
  switch (action.type) {
    case branchConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case branchConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case branchConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddBranch(state = {}, action) {
  switch (action.type) {
    case branchConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case branchConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case branchConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetBranch(state = {}, action) {
  switch (action.type) {
    case branchConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case branchConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case branchConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateBranch(state = {}, action) {
  switch (action.type) {
    case branchConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case branchConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case branchConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}